 import * as types from '../actions/types';

const initialState = {
  tempSnapshot: [],
  snapshots: [],
  snapshotActive: false,
  selectedSnapshot: {},
  showSnapshot: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SELECT_SNAPSHOT:
      return {
        ...state,
        selectedSnapshot: action.payload
      };
    case types.ACTIVATE_SNAPSHOT:
      return {
        ...state,
        snapshotActive: true,
      };
    case types.DEACTIVATE_SNAPSHOT:
      return {
        ...state,
        snapshotActive: false,
      };
    case types.GET_SNAPSHOTS_SUCCESS:
      return {
        ...state,
        snapshots: action.payload
      };
    case types.CLEAR_SNAPSHOT_LIST:
      return {
        ...state,
        snapshots: []
      };
    case types.DELETE_SNAPSHOT:
      const filteredList = state.snapshots.filter(snapshot => snapshot._id !== action.payload.id);
      return {
        ...state,
        snapshots: filteredList
      };
    case types.SAVE_SNAPSHOT:
      return {
        ...state,
        snapshots: [action.snapshot, ...state.snapshots],
      };
    case types.TEMP_SNAPSHOT:
      return {
        ...state,
        tempSnapshot: [action.tempSnapshot, ...state.tempSnapshot],
      };
    case types.SPECIMEN_SELECT:
      return {
        ...state,
        showSnapshot: false
      };
    case types.SHOW_SNAPSHOT:
      return {
        ...state,
        showSnapshot: action.payload
      };
    default:
      return state;
  }
};
